// import { useExportCampaignInfluencers } from "@entities/campaigns/lib/hooks/useExportCampaignInfluencers";
import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { CustomizeCampaignColumns } from "@features/CustomizeCampaignColumns";
// import { CampaignTimelineDrawer } from "@features/CampaignTimeline/CampaignTimelineDrawer";
// import { useHeaderDropdownStore } from "@pages/layout/DefaultLayout/lib/store";
import { useExportCampaignInfluencers } from "@entities/campaigns/lib/hooks/useExportCampaignInfluencers";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { useHeaderDropdownStore } from "@pages/layout/DefaultLayout/lib/store/useHeaderDropdownStore";
import { Button, Dropdown } from "@shared/ui";
import { DisabledPopover } from "@shared/ui/DisabledPopover";
import { CampaignTimeline } from "@widgets/CampaignTimeline/CampaignTimeline";
import { Drawer, MenuProps } from "antd";
import {
  Calendar,
  ChevronDown,
  Download,
  IndianRupee,
  LayoutDashboard,
  Loader
} from "lucide-react";
import { useState } from "react";
import styles from "./styles.module.scss";

export function CampaignExecutionDropDown({
  showPaymentColumns,
  setShowPaymentColumns,
  showDeclinedCreators,
  setShowDeclinedCreators,
  onAttachBrief,
  onAttachScript,
}: {
  showPaymentColumns?: boolean;
  setShowPaymentColumns?: (show: boolean) => void;
  showDeclinedCreators?: boolean;
  setShowDeclinedCreators?: (show: boolean) => void;
  onAttachBrief?: () => void;
  onAttachScript?: () => void;
}) {
  const [open, setOpen] = useState<boolean>(false);
  const [openTimelineDrawer, setOpenTimelineDrawer] = useState<boolean>(false);

  const { briefId } = useBriefStore();
  const { userDetails } = useGetMe();

  const isExport = true;
  // userDetails?.userEntity?.permissions?.includes("download-brand-org") ||
  // userDetails?.userEntity?.permissions?.includes("super-brand-org") ||
  // userDetails?.userEntity?.permissions.includes("super");

  const { openDropdown } = useHeaderDropdownStore();

  const { exportCampaignInfluencers, isExporting } =
    useExportCampaignInfluencers(() => {
      setOpen(false);
      openDropdown("downloads");
    });

  // Update brief store when sync completes

  const [customColumnsDrawerVisible, setCustomColumnsDrawerVisible] =
    useState<boolean>(false);

  const [metricsType, setMetricsType] = useState<"internal" | "shared" | null>(
    null
  );

  const handleMenuClick: MenuProps["onClick"] = (selectedKey) => {
    switch (selectedKey.key) {
      case "export-data":
        return;
      case "open-sheet":
        return;
      case "attach-brief":
      //   onAttachBrief?.();
      //   setOpen(false);
      //   break;
      // case "attach-script":
      //   onAttachScript?.();
      //   setOpen(false);
      //   break;
      case "open-timeline":
        setOpenTimelineDrawer(true);
        setOpen(false);
        setMetricsType(null);
        break;

      case "manage-columns":
        setCustomColumnsDrawerVisible(true);
        setOpen(false);
        setMetricsType("shared");
        break;
      // case "manage-internal-columns":
      //   setCustomColumnsDrawerVisible(true);
      //   setOpen(false);
      //   setMetricsType("internal");
      //   break;
      case "toggle-payments":
        setShowPaymentColumns?.(!showPaymentColumns);
        setOpen(false);
        break;
    }
  };

  const renderGoogleSheetMenuItem = () => {
    return {
      key: "export-data",
      label: (
        <DisabledPopover isDisabled={!isExport}>
          <div
            className={styles.menuItem}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   exportCampaignInfluencers(briefId);
            // }}
          >
            <Download size={14} />
            <span>Export Data</span>
            {isExporting && <Loader size={14} className={styles.spinner} />}
          </div>
        </DisabledPopover>
      ),
      disabled: !isExport,
      onClick: () => {
        exportCampaignInfluencers(briefId);
      },
    };
  };

  const googleSheetMenuItem = renderGoogleSheetMenuItem();

  const menuItems: MenuProps["items"] = [
    // Export Options
    // ...(googleSheetMenuItem ? [googleSheetMenuItem] : []),
    // {
    //   key: "attach-brief",
    //   label: (
    //     <div className={styles.menuItem}>
    //       <FileText size={14} />
    //       <span>Attach Brief</span>
    //     </div>
    //   ),
    // },
    // {
    //   key: "attach-script",
    //   label: (
    //     <div className={styles.menuItem}>
    //       <ScrollText size={14} />
    //       <span>Attach Script</span>
    //     </div>
    //   ),
    // },
    {
      key: "open-timeline",
      label: (
        <div className={styles.menuItem}>
          <Calendar size={14} />
          <span>Show Timeline</span>
        </div>
      ),
    },

    {
      key: "manage-columns",
      label: (
        <div className={styles.menuItem}>
          <LayoutDashboard size={14} />
          <span>Customize Columns</span>
        </div>
      ),
    },

    {
      key: "toggle-payments",
      label: (
        <div className={styles.menuItem}>
          <IndianRupee size={14} />
          <span>
            {showPaymentColumns
              ? "Hide Payment Columns"
              : "Show Payment Columns"}
          </span>
        </div>
      ),
    },
    //   {
    //   key: "showDeclinedCreators",
    //   label: <div className={styles.menuItem}>
    //     <Trash2 size={14}/>
    //     {showDeclinedCreators
    //     ? "Hide Declined Creators"
    //     : "Show Declined Creators"}
    //     </div>,
    //   onClick: () => setShowDeclinedCreators?.(!showDeclinedCreators),
    // },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        trigger={["click"]}
        open={open}
        onOpenChange={setOpen}
        placement="bottomRight"
        overlayClassName={styles.dropdownOverlay}
      >
        <Button
          className={`${styles.actionsButton} ${open ? styles.active : ""}`}
        >
          <span>Actions</span>
          <ChevronDown size={12} />
        </Button>
      </Dropdown>

      <Drawer
        open={customColumnsDrawerVisible}
        width={400}
        title="Customize Columns"
        destroyOnClose
        onClose={() => setCustomColumnsDrawerVisible(false)}
        bodyStyle={{ padding: 20 }}
      >
        <CustomizeCampaignColumns
          onClose={() => setCustomColumnsDrawerVisible(false)}
        />

        {/* <CampaignDeliverables /> */}
      </Drawer>
      <Drawer
        open={openTimelineDrawer}
        onClose={() => setOpenTimelineDrawer(false)}
        title="Campaign Timeline"
        width={500}
        footer={null}
        destroyOnClose
      >
        <CampaignTimeline
          deliverableId={""}
          onClose={() => setOpenTimelineDrawer(false)}
        />
      </Drawer>
    </>
  );
}
